/** FAQ copy in Arabic. Mirrors `../../en/home/faq.js` key for key. */

export const FAQ = {
  eyebrow: 'الأسئلة الشائعة',
  title: 'الأسئلة الشائعة',
  items: [
    {
      q: 'لمن صُمّم MeetNPlan؟',
      a: 'للشركات التي تتشارك قاعات الاجتماعات وتستقبل الزوار. يحصل كل دور على لوحته الخاصة: المستخدم، والموارد البشرية، والاستقبال، والمسؤول.',
    },
    {
      q: 'هل يعمل باللغة العربية؟',
      a: 'نعم. يعمل التطبيق بالكامل من اليمين إلى اليسار بالعربية، ويمكن لأي شخص التبديل إلى الإنجليزية.',
    },
    {
      q: 'هل يتزامن مع تقويم Google؟',
      a: 'نعم. تظهر الاجتماعات المحجوزة في MeetNPlan في تقويم Google، وتُرسل الدعوات بالبريد الإلكتروني.',
    },
    {
      q: 'كيف يسجّل الزوار دخولهم؟',
      a: 'يسجّل الاستقبال دخول الزوار المباشرين في خطوات قليلة مع توقيع، ويُسجَّل دخول كبار الضيوف بضغطة واحدة.',
    },
    {
      q: 'كيف أبدأ؟',
      a: 'احجز عرضًا تجريبيًا وسنُعدّ قاعاتك وفريقك معك.',
    },
  ],
}
